<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    action: {
      type: String,
      default: 'POST'
    }
  },

  data () {
    return {
      file: null,
      uniqid: Math.random().toString(36).substr(2)
    }
  },

  methods: {
    uploadProgress (e) {
      if (e.lengthComputable) {
        var percentComplete = Math.round(e.loaded * 100 / e.total)

        this.$emit('progress', percentComplete)
      } else {
        this.$emit('progress', false)
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        return
      }

      this.file = files[0]
      this.$emit('selected', this.file)

      var data = new FormData()
      var config = {
        onUploadProgress: this.uploadProgress
      }

      data.append('file', this.file)

      this.$emit('start', e)
      this.axios[this.action.toLowerCase()](this.url, data, config)
        .then(e => this.$emit('done', e))
        .catch(e => this.$emit('error', e))
        .finally(() => {
          this.file = null
          this.$refs.file.value = ''
        })
    }
  }
}
</script>

<template>
  <label :for="uniqid">
    <input type="file" ref="file" :id="uniqid" name="fileUpload" @change="onFileChange">
    <slot></slot>
  </label>
</template>

<style lang="scss" scoped>
input {
  overflow: hidden;
  position: absolute;
  left: -9999px;
  height: 0;
  width: 0;
}
</style>



// WEBPACK FOOTER //
// Uploader.vue?5ab895f4